module.exports = __webpack_public_path__ + "static/media/temperature.46aa7031.jpg";